import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";
/*
<ng-container *ngIf="formStatus !== 0"> 
      <krefield-private_text [field]="field" [status]="formStatus"></krefield-private_text>
    </ng-container>
*/
@Component({
  selector: "krefield-text",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <input nz-input disabled />
      </div>
    </ng-container>
    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <input
          nz-input
          autocomplete="off"
          [formControl]="formControl"
          [kreFormAttributes]="field"
          [placeholder]="placeHolder"
          [class.is-invalid]="showError"
          [maxLength]="to.maxLength || 200"
          [minLength]="to.minLength || 0"
        />
        <!-- <div class="tips">
          <i
            class="icon-bangzhu"
            [nzTooltipTitle]="tips"
            nzTooltipPlacement="top"
            nz-tooltip
            *ngIf="tips != ''"
          ></i>
        </div> -->
      </ng-container>

      <div class="fieldtext" *ngIf="editor === false">{{ text }}</div>
    </ng-template>
  `,
})
export class KreFormFieldText extends FieldType {}
